import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the page was prerendered (the #root already contains static HTML written
// by the prerender step), hydrate it so Google sees real content in the source
// and the app still becomes interactive. Otherwise do a normal client render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
